import "@arco-design/web-react/es/Trigger/style";
import _Trigger from "@arco-design/web-react/es/Trigger";
import "@arco-design/web-react/es/Badge/style";
import _Badge from "@arco-design/web-react/es/Badge";
import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import "@arco-design/web-react/es/Tabs/style";
import _Tabs from "@arco-design/web-react/es/Tabs";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Avatar/style";
import _Avatar from "@arco-design/web-react/es/Avatar";
import _IconDesktop from "@arco-design/web-react/icon/react-icon/IconDesktop";
import _IconFile from "@arco-design/web-react/icon/react-icon/IconFile";
import _IconCustomerService from "@arco-design/web-react/icon/react-icon/IconCustomerService";
import _IconMessage from "@arco-design/web-react/icon/react-icon/IconMessage";
import React, { useEffect, useState } from "react";
import axios from "axios";
import groupBy from "lodash/groupBy";
import useLocale from "../../utils/useLocale";
import MessageList from "./list";
import styles from "./style/index.module.less";

function DropContent() {
  const t = useLocale();
  const [loading, setLoading] = useState(false);
  const [groupData, setGroupData] = useState({});
  const [sourceData, setSourceData] = useState([]);

  function fetchSourceData(showLoading = true) {
    showLoading && setLoading(true);
    axios.get("/api/message/list").then(res => {
      setSourceData(res.data);
    }).finally(() => {
      showLoading && setLoading(false);
    });
  }

  function readMessage(data) {
    const ids = data.map(item => item.id);
    axios.post("/api/message/read", {
      ids
    }).then(() => {
      fetchSourceData();
    });
  }

  useEffect(() => {
    fetchSourceData();
  }, []);
  useEffect(() => {
    const groupData = groupBy(sourceData, "type");
    setGroupData(groupData);
  }, [sourceData]);
  const tabList = [{
    key: "message",
    title: t["message.tab.title.message"],
    titleIcon: /*#__PURE__*/React.createElement(_IconMessage, null)
  }, {
    key: "notice",
    title: t["message.tab.title.notice"],
    titleIcon: /*#__PURE__*/React.createElement(_IconCustomerService, null)
  }, {
    key: "todo",
    title: t["message.tab.title.todo"],
    titleIcon: /*#__PURE__*/React.createElement(_IconFile, null),
    avatar: /*#__PURE__*/React.createElement(_Avatar, {
      style: {
        backgroundColor: "#0FC6C2"
      }
    }, /*#__PURE__*/React.createElement(_IconDesktop, null))
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: styles["message-box"]
  }, /*#__PURE__*/React.createElement(_Spin, {
    loading: loading,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement(_Tabs, {
    overflow: "dropdown",
    type: "rounded",
    defaultActiveTab: "message",
    destroyOnHide: true,
    extra: /*#__PURE__*/React.createElement(_Button, {
      type: "text",
      onClick: () => setSourceData([])
    }, t["message.empty"])
  }, tabList.map(item => {
    const {
      key,
      title,
      avatar
    } = item;
    const data = groupData[key] || [];
    const unReadData = data.filter(item => !item.status);
    return /*#__PURE__*/React.createElement(_Tabs.TabPane, {
      key: key,
      title: /*#__PURE__*/React.createElement("span", null, title, unReadData.length ? `(${unReadData.length})` : "")
    }, /*#__PURE__*/React.createElement(MessageList, {
      data: data,
      unReadData: unReadData,
      onItemClick: item => {
        readMessage([item]);
      },
      onAllBtnClick: unReadData => {
        readMessage(unReadData);
      }
    }));
  }))));
}

function MessageBox({
  children
}) {
  return /*#__PURE__*/React.createElement(_Trigger, {
    trigger: "hover",
    popup: () => /*#__PURE__*/React.createElement(DropContent, null),
    position: "br",
    unmountOnExit: false,
    popupAlign: {
      bottom: 4
    }
  }, /*#__PURE__*/React.createElement(_Badge, {
    count: 9,
    dot: true
  }, children));
}

export default MessageBox;